import agent from 'superagent';
import { Query } from 'acast-reactor';
import baseUrl from 'server/routes/base-url';

export default Query.define('GetCuratedContent', (view, country = 'us') => {
  return new Promise((resolve, reject) => {
    agent.get(`${baseUrl}api/cc/${country}/${view}`).end((err, res) => {
      if (err) {
        return reject(err);
      }
      resolve(res.body);
    });
  });
});



// WEBPACK FOOTER //
// ./client/queries/get-curated-content.es6